
export const RETARGETING_CONFIG_REQUEST = 'RETARGETING_CONFIG_REQUEST';
export const RETARGETING_CONFIG_SUCCESS = 'RETARGETING_CONFIG_SUCCESS';
export const RETARGETING_CONFIG_FAILED = 'RETARGETING_CONFIG_FAILED';

export const RetargetingConfigAction = (data: any) => {
    return { type: RETARGETING_CONFIG_REQUEST, payload: data }
}